import { render, staticRenderFns } from "./AttendanceSummary.vue?vue&type=template&id=56c58d10&scoped=true"
import script from "./AttendanceSummary.vue?vue&type=script&lang=js"
export * from "./AttendanceSummary.vue?vue&type=script&lang=js"
import style0 from "./AttendanceSummary.vue?vue&type=style&index=0&id=56c58d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c58d10",
  null
  
)

export default component.exports